import { Component } from '@angular/core';
import { NotificationDTO, NotificationService } from '../../_services/notification.service';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { DialogService } from '../../_modal/dialog.service';
import { environment } from '../../../../environments/environment';
import { CustomizerSettingsService } from '../../../customizer-settings/customizer-settings.service';

@Component({
  selector: 'app-notifications',
  standalone: true,
  imports: [CommonModule,FormsModule],
  templateUrl: './notifications.component.html',
  styleUrl: './notifications.component.scss'
})
export class NotificationsComponent {

  notifications: NotificationDTO[] = [];

  constructor(private notificationService: NotificationService,private dialogService: DialogService,public themeService: CustomizerSettingsService
  ) {}

  ngOnInit(): void {
     this.loadNotifications()
  }
  loadNotifications(): void {
    const userId = Number(sessionStorage.getItem('user_id'));
  
    if (!isNaN(userId)) {  
      this.notificationService.getNotificationsFromDB(userId).subscribe(notifs => {
      this.notifications = notifs.reverse();
      }, error => {
        console.error('Erreur lors du chargement des notifications depuis la BDD:', error);
      });
  
    } else {
      console.warn('Aucun utilisateur connecté.');
    }
  }
  
  

  deleteNotif(id: number): void {
        this.notificationService.deleteNotification(id).subscribe(
          () => {
            this.loadNotifications(); 
          },
          (error) => {
            console.error('Error deleting notification:', error);
          }
        );
      }
  
  

}
